import React, { useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { companyInfo } from '../../data/mockData';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 px-6 md:px-12 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_modern-gomobyle/artifacts/983mgmi8_Untitled%20design%20%281%29.png" 
              alt="Mobyle Logo" 
              className="h-12 w-auto"
            />
            <span className="hidden md:block text-xs tracking-[0.2em] text-gray-600 uppercase">
              Full-Service Digital Agency
            </span>
          </div>

          {/* Right side */}
          <div className="flex items-center gap-4">
            <a
              href="#contact"
              className="hidden md:flex items-center gap-2 px-6 py-3 border border-black rounded-full text-sm font-medium hover:bg-black hover:text-white transition-colors duration-300"
            >
              Hire us <ArrowRight size={16} />
            </a>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="w-12 h-12 rounded-full border border-black flex items-center justify-center hover:bg-black hover:text-white transition-colors duration-300"
            >
              {menuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </header>

      {/* Full screen menu */}
      <div
        className={`fixed inset-0 bg-[#0a0a0a] z-40 transition-transform duration-500 ease-in-out ${
          menuOpen ? 'translate-y-0' : '-translate-y-full'
        }`}
      >
        <div className="h-full flex flex-col justify-center items-center text-white">
          <nav className="flex flex-col items-center gap-8">
            {[
              { name: 'Services', href: '/#services' },
              { name: 'Work', href: '/#work' },
              { name: 'About', href: '/about' },
              { name: 'Results', href: '/#results' },
              { name: 'Contact', href: '/#contact' }
            ].map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="text-5xl md:text-7xl font-light hover:text-gray-400 transition-colors duration-300"
              >
                {item.name}
              </a>
            ))}
          </nav>
          <div className="mt-16 text-gray-500 text-sm tracking-wider">
            {companyInfo.email}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
